import { v4 as uuidv4 } from 'uuid'
import { getCookieStore } from './getCookieStore.helper'
import type {
  CookieStoreOrString,
  FeatureFlagCookieStore,
} from '@/types/FeatureFlagCookies.type'

export const FEATURE_FLAG_UUID_COOKIE_NAME = 'feature_flag_uuid'

export type GetFeatureFlagUUIDOptions = {
  cookies?: FeatureFlagCookieStore
}

/**
 * Gets the UUID of the feature flag from cookies.
 *
 * @param options - Optional configuration for getting the UUID.
 * @returns The UUID of the feature flag, or undefined if not set.
 */
export function getFeatureFlagUUID(
  options?: GetFeatureFlagUUIDOptions,
): string | undefined {
  const cookieStore = getCookieStore(options?.cookies)
  return cookieStore?.get(FEATURE_FLAG_UUID_COOKIE_NAME)
}

/**
 * Creates a new UUID for using as a feature flag identifier.
 */
export function createFeatureFlagUUID() {
  return String(uuidv4())
}

/**
 * Ensures that a UUID cookie is set for feature flags.
 *
 * @param cookies - Optional string of cookies to use instead of document.cookie.
 *
 * @returns The UUID that was set or already exists in the cookie.
 */
export function ensureUUIDCookie(cookies?: CookieStoreOrString) {
  const cookieStore = getCookieStore(cookies)

  const featureFlagId = cookieStore?.get(FEATURE_FLAG_UUID_COOKIE_NAME)

  if (featureFlagId) return featureFlagId

  const uuid = createFeatureFlagUUID()

  cookieStore?.set(FEATURE_FLAG_UUID_COOKIE_NAME, uuid, {
    expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 1 year,
  })

  return uuid
}
